import "./Events.module.css";
import Header from "@/reusable_sections/Header";
import LouezVotreVoitureAuMeilleurPrix from "./sections/LouezVotreVoitureAuMeilleurPrix";
import UpcomingEvents from "./sections/UpcomingEvents";
import MediaLinks from "./sections/MediaLinks";
import Gallery from "./sections/Gallery";
import YeFooter from "@/reusable_sections/Footer";
export default function EventsPage() {
  return <div>
      <Header />
      <LouezVotreVoitureAuMeilleurPrix />
      <UpcomingEvents />
      <MediaLinks />
      <Gallery />
      <YeFooter />
    </div>;
}